import React from 'react'
import {
  Control,
  FieldValues,
  UseFormClearErrors,
  UseFormSetValue,
  UseFormTrigger,
  UseFormWatch
} from 'react-hook-form'

import { Typography, Stack } from '@mui/material'

import AdjustmentAccordion from '../AdjustmentAccordion'
import Discounts from './components/Discounts'
import Fees from './components/Fees'
import IdentifyInternal from './components/IdentifyInternal/IdentifyInternal/IdentifyInternal'
import Invoice from './components/Invoice'
import Negativation from './components/Negativation'

export interface OptionsAdditionalsProps<T extends FieldValues> {
  control: Control<T, object>
  watch: UseFormWatch<T>
  setValue: UseFormSetValue<T>
  trigger: UseFormTrigger<T>
  clearErrors: UseFormClearErrors<T>
  recurrence?: boolean
  isEditing?: boolean
  hideNegativation?: boolean
  isEditingRecurrence?: boolean
  isProductOrLink?: boolean
  isUnique?: boolean
  totalCycles?: number
  externalReplaceDiscounts?: (discounts: any[]) => void
  // Props for AdjustmentAccordion
  recurrenceFrequency?: number
  currentCycle?: number
  currentCycleDueDate?: string
}

const OptionsAdditionals = <T extends FieldValues>({
  control,
  watch,
  recurrence,
  setValue,
  trigger,
  clearErrors,
  isEditing,
  hideNegativation,
  isEditingRecurrence,
  isProductOrLink = false,
  isUnique = false,
  totalCycles = 0,
  externalReplaceDiscounts,
  recurrenceFrequency,
  currentCycle,
  currentCycleDueDate
}: OptionsAdditionalsProps<T>) => {
  return (
    <Stack gap={1} mt={2}>
      <Typography variant="mdBold">Configurações extras</Typography>

      <Stack gap={1.5}>
        <Discounts
          control={control}
          watch={watch}
          setValue={setValue}
          clearErrors={clearErrors}
          recurrence={recurrence}
          isEditingRecurrence={isEditingRecurrence}
          isProductOrLink={isProductOrLink}
          externalReplaceDiscounts={externalReplaceDiscounts}
        />

        <Fees control={control} setValue={setValue} />

        <AdjustmentAccordion
          control={control}
          watch={watch}
          setValue={setValue}
          trigger={trigger}
          clearErrors={clearErrors}
          isUnique={isUnique}
          totalCycles={totalCycles}
          isEdit={isEditingRecurrence}
          recurrenceFrequency={recurrenceFrequency}
          currentCycle={currentCycle}
          currentCycleDueDate={currentCycleDueDate}
          isProductOrLink={isProductOrLink}
        />

        <Invoice
          control={control}
          watch={watch}
          setValue={setValue}
          isEditing={isEditing}
          isRecurrence={recurrence}
        />

        {!hideNegativation && (
          <Negativation control={control} setValue={setValue} />
        )}

        <IdentifyInternal control={control} setValue={setValue} />
      </Stack>
    </Stack>
  )
}

export default OptionsAdditionals
